import { render, staticRenderFns } from "./ObjectInfo.vue?vue&type=template&id=4230337f&scoped=true"
import script from "./ObjectInfo.vue?vue&type=script&lang=ts"
export * from "./ObjectInfo.vue?vue&type=script&lang=ts"
import style0 from "./ObjectInfo.vue?vue&type=style&index=0&id=4230337f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4230337f",
  null
  
)

export default component.exports